import { deleteCookie, getCookie, setCookie } from '../../utils/cookie';

export const reloadFlow = () => {
    window.location.reload();
};

export const dismissBucketToast = () => {
    const bucketCookie = getCookie('stageval');

    if (bucketCookie) {
        deleteCookie('stageval');
        reloadFlow();
    }
};

export const toggleBucket = () => {
    const bucketCookie = getCookie('stageval');

    if (bucketCookie) {
        deleteCookie('stageval');
    } else {
        setCookie('stageval', 'foo');
    }

    reloadFlow();
};
